import React from "react";

const muscleGroups = ['chest', 'back', 'shoulders', 'biceps', 'triceps', 'legs', 'core', 'glutes'];
const categories = ['stretching', 'powerlifting', 'plyometrics', 'strength'];
const levels = ['beginner', 'intermediate', 'expert'];

const WorkoutForm = ({
  selectedGroups,
  setSelectedGroups,
  exerciseCount,
  setExerciseCount,
  selectedCategory,
  setSelectedCategory,
  selectedLevel,
  setSelectedLevel,
  handleGenerate
}) => {
  const toggleGroup = (group) => {
    if (selectedGroups.includes(group)) {
      setSelectedGroups(selectedGroups.filter((g) => g !== group));
    } else {
      setSelectedGroups([...selectedGroups, group]);
    }
  };

  const increment = () => {
    if (exerciseCount < 10) {
      setExerciseCount(exerciseCount + 1);
    }
  };

  const decrement = () => {
    if (exerciseCount > 1) {
      setExerciseCount(exerciseCount - 1);
    }
  };

  return (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold">1. Muscle Groups</h2>
      <div className="flex flex-wrap gap-2">
        {muscleGroups.map((group) => (
          <button
            key={group}
            onClick={() => toggleGroup(group)}
            className={`px-4 py-2 rounded text-sm capitalize ${
              selectedGroups.includes(group)
                ? "bg-blue-600 text-white"
                : "bg-gray-200"
            }`}
          >
            {group}
          </button>
        ))}
      </div>

      <div className="space-y-2">
        <h2 className="text-xl font-semibold">2. Category</h2>
        <div className="flex flex-wrap gap-2">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`px-4 py-2 rounded text-sm capitalize ${
                selectedCategory === category
                  ? "bg-purple-600 text-white"
                  : "bg-gray-200"
              }`}
            >
              {category}
            </button>
          ))}
        </div>
      </div>

      <div className="space-y-2">
        <h2 className="text-xl font-semibold">3. Level</h2>
        <div className="flex flex-wrap gap-2">
          {levels.map((level) => (
            <button
              key={level}
              onClick={() => setSelectedLevel(level)}
              className={`px-4 py-2 rounded text-sm capitalize ${
                selectedLevel === level
                  ? "bg-teal-600 text-white"
                  : "bg-gray-200"
              }`}
            >
              {level}
            </button>
          ))}
        </div>
      </div>

            <div className="space-y-2">
        <h2 className="text-xl font-semibold">4. Number of Exercises</h2>
        <div className="flex items-center gap-4">
          <button
            onClick={decrement}
            className="px-3 py-1 bg-gray-300 hover:bg-gray-400 text-lg rounded"
          >
            −
          </button>
          <div className="text-lg font-medium w-8 text-center">{exerciseCount}</div>
          <button
            onClick={increment}
            className="px-3 py-1 bg-gray-300 hover:bg-gray-400 text-lg rounded"
          >
            +
          </button>
        </div>
      </div>

      <button
        onClick={handleGenerate}
        className="mt-6 px-6 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg transition duration-200"
      >
        Generate Workout
      </button>
    </div>
  );
};

export default WorkoutForm;
